import React from "react";
import { Link } from "react-router-dom";
import "./cta-button.css";

const CTAButton = ({
  text,
  link,
  type = "",
  specialClass = "",
  blank = false,
  onClick,
  disabled = false,
  children,
}) => {
  const buttonClasses = `cta-button ${specialClass}`;

  if (type === "submit" || onClick) {
    return (
      <button
        type={type}
        className={buttonClasses}
        onClick={onClick}
        disabled={disabled}
      >
        {children || text}
      </button>
    );
  }

  if (link) {
    if (blank) {
      return (
        <Link to={link} target="_blank" className="cta-button-wrapper">
          <button className={buttonClasses} disabled={disabled}>
            {children || text}
          </button>
        </Link>
      );
    } else {
      return (
        <Link to={link} className="cta-button-wrapper">
          <button className={buttonClasses} disabled={disabled}>
            {children || text}
          </button>
        </Link>
      );
    }
  }

  return (
    <button className={buttonClasses} onClick={onClick} disabled={disabled}>
      {children || text}
    </button>
  );
};

export default CTAButton;
